/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuConfigurationResponse } from '../../models/menu-configuration-response';

export interface PublishConfigsPublishConfigIdGet$Params {
  publishConfigId: string;
  'Active-Tenant-Identifier': string;
}

export function publishConfigsPublishConfigIdGet(http: HttpClient, rootUrl: string, params: PublishConfigsPublishConfigIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuConfigurationResponse>> {
  const rb = new RequestBuilder(rootUrl, publishConfigsPublishConfigIdGet.PATH, 'get');
  if (params) {
    rb.path('publishConfigId', params.publishConfigId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuConfigurationResponse>;
    })
  );
}

publishConfigsPublishConfigIdGet.PATH = '/publish-configs/{publishConfigId}';
